import { INVITATION_STATUS, MEETING_STATUS } from './constants';
import $ from 'jquery';
import moment from 'moment';

export const getErrorMessages = errorsJSON => {
    let errorMessages = '';
    for (const errorKey in errorsJSON) {
        if (Object.prototype.hasOwnProperty.call(errorsJSON, errorKey)) {
            const messages = errorsJSON[errorKey];
            for (const messageIndex in messages) {
                if (Object.prototype.hasOwnProperty.call(messages, messageIndex)) {
                    const uniqueEmailErrorMessage = messages[messageIndex];
                    if (errorKey == 'email' && uniqueEmailErrorMessage == 'Esse campo deve ser  único.') {
                        errorMessages += 'O e-mail escolhido já está cadastrado no sistema.';
                    } else {
                        errorMessages += messages[messageIndex];
                    }
                    errorMessages += ' ';
                }
            }
        }
    }

    return errorMessages.trim();
};

export const getFiles = inputElement => {
    const deferred = $.Deferred();
    const files = [];
    const attachmentsInput = inputElement;
    const totalOfAttachments = attachmentsInput.files.length;

    if (totalOfAttachments == 0) {
        deferred.resolve([]);
    }

    for (let i = 0; i < totalOfAttachments; i++) {
        convertFileToBase64(attachmentsInput.files[i], i).done(result => {
            const base64Data = result.base64Data;
            const index = result.index;
            const base64File = base64Data ? base64Data : '';
            files.push({
                file: base64File,
                file_name: attachmentsInput.files[index].name
            });

            if (i >= totalOfAttachments - 1 && files.length == totalOfAttachments) {
                deferred.resolve(files);
            }
        });
    }
    return deferred.promise();
};

export const prepareSingleFileToUpload = async file => {
    const fileBase64 = await convertFileToBase64(file);
    const fileName = file.name;

    return { file: fileBase64, file_name: fileName };
};

export const convertFileToBase64 = file => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
};

export const appendErrorMessage = (error, element) => {
    const placement = $(element).data('error');
    if (placement) {
        $(placement).append(error);
    } else {
        const labelElement = element.siblings('label');
        const inputFieldGrandfather = element.closest('div.input-field');
        if (labelElement.length > 0) {
            error.insertAfter(labelElement);
        } else if (inputFieldGrandfather.length > 0) {
            error.insertAfter(inputFieldGrandfather);
        } else {
            error.insertAfter(element);
        }
    }
};

export const getParameterByName = (name, url) => {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const convertNumberToIntegerFormat = number => {
    const numberFormatted = number.toLocaleString('pt-BR', {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    });

    return numberFormatted;
};

export const convertNumberToFloatFormat = number => {
    const numberFormatted = number.toLocaleString('pt-BR', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });

    return numberFormatted;
};

export const convertNumberToBRL = number => {
    number = number.toFixed(2).split('.');
    number[0] = 'R$ ' + number[0].split(/(?=(?:...)*$)/).join('.');
    return number.join(',');
};

export const clearAllFileInputs = (clearBtnSelector, inputFileSelector, fileNameSelector, callback) => {
    $(clearBtnSelector).on('click', () => {
        const inputFile = $(inputFileSelector);
        inputFile.replaceWith(inputFile.val('').clone(true));

        $(fileNameSelector).val('');

        callback = callback || function() {};

        callback();
    });
};

export const removeCurrencyFormat = currencyString => {
    currencyString = currencyString.toString();
    currencyString = currencyString.replace(/\./g, '');
    currencyString = currencyString.replace(/\,/g, '.'); // eslint-disable-line
    return currencyString.replace('R$', '').trim();
};

export const showErrorModalByStatus = status => {
    if (status == 401 || status == 403 || status == 404) {
        $('#unauthorized-error-modal').modal('open');
    } else if (status == 400 || status == 500) {
        $('#internal-error-modal').modal('open');
    }
};

export const truncate = (text, length) => {
    if (text.length > length) {
        return text.substring(0, length) + '...';
    } else {
        return text;
    }
};

export const showGenericErrorModal = () => {
    $('#internal-error-modal').modal('open');
};

export const selectAllCheckboxes = checkboxesSelector => {
    $(checkboxesSelector).each(() => {
        $.this = $(this);
        $.this.prop('checked', true);
    });
};

export const unselectAllCheckboxes = checkboxesSelector => {
    $(checkboxesSelector).each(() => {
        $.this = $(this);
        $.this.prop('checked', false);
    });
};

export const formatReadOnlyDate = element => {
    const currentDate = new Date(element.html().trim());
    const formattedDate = moment.utc(currentDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    element.html(formattedDate);
};

export const formatReadOnlyDateMinusBusinessDays = element => {
    const currentDate = new Date(element.text().trim());
    const formattedDate = moment.utc(currentDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    element.text(formattedDate);
};

export const formatDateInputMinusBusinessDays = element => {
    const currentDate = new Date(element.val().trim());
    const formattedDate = moment.utc(currentDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    element.val(formattedDate);
};

export const formatDateInput = element => {
    const currentDate = new Date(element.val().trim());
    const formattedDate = moment.utc(currentDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    element.val(formattedDate);
};

export const setContactText = text => {
    if (text) {
        return text;
    } else {
        return '-';
    }
};

export const getCompetitionObjectiveText = value => {
    if (value == 1) {
        return 'Serviço';
    } else if (value == 2) {
        return 'Equipamento';
    } else if (value == 3) {
        return 'Produto';
    }
    return '';
};

export const getContractorStatusClass = status => {
    if (status == 4) {
        return 'analysis';
    } else if (status == 1) {
        return 'opened';
    } else if (status == 2 || status == 6) {
        return 'pending';
    } else if (status == 3) {
        return 'closed';
    }
    return '';
};

export const getSupplierStatusClass = status => {
    if (status == 1 || status == 2 || status == 4 || status == 6) {
        return 'opened';
    } else if (status == 3) {
        return 'closed';
    }

    return '';
};

export const urlHasQueryString = url => {
    return url.indexOf('?') != -1;
};

export const getStatusText = status => {
    switch (status) {
    case INVITATION_STATUS.PROPOSAL_SENT:
        return 'Proposta enviada';
    case INVITATION_STATUS.EMAIL_DECLINED:
        return 'Participação rejeitada';
    case INVITATION_STATUS.EMAIL_OPEN:
        return 'Email aberto';
    case INVITATION_STATUS.EMAIL_REJECTED:
        return 'Participação rejeitada';
    case INVITATION_STATUS.FEEDBACK_SENT:
        return 'Feedback enviado';
    case INVITATION_STATUS.FEEDBACK_VISUALIZED:
        return 'Feedback visualizado';
    case INVITATION_STATUS.LEAD_VISUALIZED:
        return 'Contato visualizado';
    case INVITATION_STATUS.NOT_VISUALIZED:
        return 'Detalhes da cotação não visualizado';
    case INVITATION_STATUS.PANEL_CREDIT_CONSUMED:
        return 'Crédito do painel consumido';
    case INVITATION_STATUS.PAYMENT_ACCEPTED:
        return 'Pagamento realizado';
    case INVITATION_STATUS.PAYMENT_CONFIRMED:
        return 'Pagamento confirmado';
    case INVITATION_STATUS.PAYMENT_PENDING:
        return 'Pagamento pendente';
    case INVITATION_STATUS.PAYMENT_TEST_VISUALIZED:
        return 'Pergunta de pagamento visualizada';
    case INVITATION_STATUS.PAYMENT_VISUALIZED:
        return 'Tela de pagamento visualizada';
    case INVITATION_STATUS.SIGNUP_COMPLETED:
        return 'Cadastro completo';
    case INVITATION_STATUS.SIGNUP_VISUALIZED:
        return 'Cadastro visualizado';
    case INVITATION_STATUS.VISUALIZED:
        return 'Detalhes da cotação visualizado';
    case INVITATION_STATUS.FREE_OCCUPATION:
        return 'Ocupação gratuita';
    case INVITATION_STATUS.PANEL_BONUS_CASH_CONSUMED:
        return 'Bônus utilizado';
        // case INVITATION_STATUS.PANEL_CREDIT_CONSUMED:
        //   return "Crédito utilizado";
    case INVITATION_STATUS.PANEL_LEAD_CASH_CONSUMED:
        return 'Moedas utilizadas';
    default:
        return 'Status desconhecido';
    }
};

export const getFeedbackOptions = () => {
    return [
        'Não conheço a construtora',
        'Não conheço a plataforma Engelink',
        'Não tenho alçada para fazer pagamentos dentro de minha empresa',
        'O valor cobrado pelo contato deste cliente é muito caro',
        'Eu nunca pagaria pelo contato de um novo cliente',
        'A cotação tinha dados insuficientes'
    ];
};

export const getSelectOptionText = (options, value) => {
    let selectedText = '';
    options.forEach(option => {
        if (option.value == value) {
            selectedText = option.name;
        }
    });

    return selectedText;
};

export const getLandingPageLogosSorted = () => {
    return [
        'Alphaville',
        'Carioca Engenharia',
        'CIPA',
        'Estasa',
        'Estácio',
        'Lowndes',
        'Multiplan',
        'Vasco',
        'Cassi',
        'Fasano',
        'Flamengo',
        'Icatu',
        'Leroy Merlin',
        'Renner',
        'Shopping da Gávea',
        'Shopping Nova América',
        'Citta',
        'Fundação Bradesco',
        'Hydronorth',
        'Marriott',
        'Papelex',
        'Saint Gobain',
        'Shopping Fashion Mall',
        'Viapol'
    ];
};

export const getSubscriptionLogosSorted = () => {
    return [
        'carioca-engenharia.svg',
        'Arcelor+Mittal.png',
        'Saint-Gobain.png',
        'denver.svg',
        'citta.svg',
        'SIKA.png',
        'gavea.svg',
        'Papelex.png',
        'aguas-niteroi.svg',
        'Mills.png',
        'Edifício+Avenida+Central.png',
        'Novacais.png',
        'montserrat.svg',
        'seel.svg',
        'Construcola.png',
        'viapol.svg',
        'A+Geradora.png',
        'texsa.svg',
        'g2o.svg',
        'Crater+Construções.png',
        'Entre+os+Rios.png',
        'Volo+Engenharia.png',
        'Ono+Poke.png',
        'Sindicato+dos+Despachantes.png',
        'Via+Alto+Mapendi.png',
        'betumat.svg',
        'mc.svg',
        'SH+Fôrmas.png',
        'Multibloco.png',
        'finxi-logo.png',
        '3h.svg',
        'Polimix.png',
        'Supermix.png',
        'Redimix.png',
        'Concrelagos.png',
        'Hidrocenter.png',
        'Icobit.png',
        'grupo_persona.svg',
        'stylus.svg',
        'fort.svg',
        'Argamil.png',
        'Tecnobre.png',
        'Ambientair.png',
        'Trimak.png',
        'nsi.svg',
        'Vanther.png',
        'Rodantech.png',
        'Orguel.png',
        'NS+Brazil.png',
        'winrocha.svg',
        'Angel_s.png',
        'Biosíndico.png',
        'opus.svg',
        'gamma.svg',
        'ison_projetos.svg',
        'Royal+Blue.png',
        'Solução+Ideal.png',
        'Henac.png',
        'Espaço+São+Clemente.png',
        'Brasport.png',
        'Condomínio+Sabará.png',
        'retrofit.svg',
        'reinventa.svg',
        'climb.svg',
        'illuminare.svg',
        'Maria+Brasileira.png',
        'Mary+Help.png',
        'Dryko.png',
        'Otto+Plataformas.png',
        'fator.svg',
        'Renove+Engenharia.png',
        'frontal.svg',
        'Arga+Rio.png',
        'Brasibloco.png',
        'Grupo+Santa+Luzia.png',
        'M+Marins.png',
        'CityLar.png',
        'Franik.png',
        'Flaviense.png',
        'Biglar.png',
        'Grupo+Hawk.png',
        'Fluzão.png',
        'MMG+Extintores.png',
        'Formicenter.png',
        'Embelezart+Elevadores.png',
        'Atual+Engenharia.png',
        'absoluto.svg',
        'paradiso.svg',
        'Bénéfice+Engenharia.png',
        'start-consultoria.svg',
        'Charitas+Offices.png',
        'Domus+Soluções+Sustentáveis.png',
        'MV+Engenharia.png',
        'Montaggio.png',
        'RMZ+Engenharia.png',
        'Solit+Engenharia.png',
        'Souza+Dutra.png',
        'UP+Representação.png',
        'W3+Engenharia.png',
        'Acarita.png',
        'Foxcel.png',
        'Trenamar.png',
        'Rima.png',
        'diba+695.png',
        'Trelar+Madeiras.png',
        'Recremat.png',
        'Boaseg.png',
        'Isocom.png',
        'impro.png',
        'Loja+da+Impermeabilização.png',
        'Loja+do+Impermeabilizador.png',
        'Nobretec.png',
        'Casa+do+Construtor.png',
        'Portobello+Shop.png',
        'BRAGAL.png',
        'Casa+das+Fechaduras.png',
        'KSI.png',
        'Ferragens+Deka.png',
        'Hydronorth.png',
        'Hiper+Pedras.png',
        'Bomfim+Engenharia.png',
        'franco.svg'
    ];
};

export const getBrazilianStates = () => {
    return [
        { label: 'Acre', value: 'AC' },
        { label: 'Alagoas', value: 'AL' },
        { label: 'Amazonas', value: 'AM' },
        { label: 'Amapá', value: 'AP' },
        { label: 'Bahia', value: 'BA' },
        { label: 'Ceará', value: 'CE' },
        { label: 'Distrito Federal', value: 'DF' },
        { label: 'Espírito do Santo', value: 'ES' },
        { label: 'Goiás', value: 'GO' },
        { label: 'Maranhão', value: 'MA' },
        { label: 'Minas', value: 'MG' },
        { label: 'Mato Grosso do Sul', value: 'MS' },
        { label: 'Mato Grosso', value: 'MT' },
        { label: 'Pará', value: 'PA' },
        { label: 'Paraíba', value: 'PB' },
        { label: 'Pernambuco', value: 'PE' },
        { label: 'Piauí', value: 'PI' },
        { label: 'Paraná', value: 'PR' },
        { label: 'Rio de Janeiro', value: 'RJ' },
        { label: 'Rio Grande do Norte', value: 'RN' },
        { label: 'Rondônia', value: 'RO' },
        { label: 'Roraima', value: 'RR' },
        { label: 'Rio Grande do Sul', value: 'RS' },
        { label: 'Santa Catarina', value: 'SC' },
        { label: 'Sergipe', value: 'SE' },
        { label: 'São Paulo', value: 'SP' },
        { label: 'Tocantins', value: 'TO' }
    ];
};

export const getCompetitionPanelStates = () => {
    return [
        { label: 'Bahia', value: 'BA' },
        { label: 'Ceará', value: 'CE' },
        { label: 'Distrito Federal', value: 'DF' },
        { label: 'Goiás', value: 'GO' },
        { label: 'Mato Grosso', value: 'MT' },
        { label: 'Minas Gerais', value: 'MG' },
        { label: 'Paraná', value: 'PR' },
        { label: 'Pernambuco', value: 'PE' },
        { label: 'Rio de Janeiro', value: 'RJ' },
        { label: 'Rio Grande do Sul', value: 'RS' },
        { label: 'São Paulo', value: 'SP' },
        { label: 'Santa Catarina', value: 'SC' }
    ];
};

export const getServiceQuestions = () => {
    return [
        {
            checked: false,
            text: 'Considerou o canteiro por conta do contratado, inclusive área disponível?'
        },
        { checked: false, text: 'Refeição está coberta pelo orçamento?' },
        { checked: false, text: 'Ponto de água e luz previsto no orçamento?' },
        {
            checked: false,
            text:
                'Exames dos funcionários contemplados no orçamento (ex. aso, complementares para espaço confinado e trabalho em altura)?'
        },
        {
            checked: false,
            text: 'O orçamento cobre a obrigatoriedade de técnico de segurança?'
        },
        {
            checked: false,
            text: 'Epi\'s obrigatórios contemplados no orçamento?'
        },
        {
            checked: false,
            text: 'Treinamentos específicos previstos no orçamento (ex: trabalho em altura, espaço confinado?)'
        },
        { checked: false, text: 'Forma de pagamento?' },
        { checked: false, text: 'Está considerando sinal?' },
        { checked: false, text: 'Considerou faturamento direto no orçamento?' },
        { checked: false, text: 'O que pretende faturar direto?' },
        {
            checked: false,
            text: 'Qual estimativa de verba para faturamento direto?'
        },
        { checked: false, text: 'Imposto do local da obra?' },
        {
            checked: false,
            text: 'Verba de manutenção de canteiro, por funcionário no caso de grandes obras?'
        },
        {
            checked: false,
            text: 'Possui Certidão Negativa de Débito de tributos federais?'
        },
        { checked: false, text: 'Possui Certidão Negativa de Débito de ISS?' },
        { checked: false, text: 'Possui Certidão Negativa de Débito de FGTS?' },
        { checked: false, text: 'Custo de emissão de ART previstos?' }
    ];
};

export const getEquipmentQuestions = () => {
    return [
        { checked: false, text: 'Frete incluso?' },
        { checked: false, text: 'Manutenção necessária incluída?' },
        {
            checked: false,
            text: 'Prazo de troca em caso de pane no equipamento?'
        },
        { checked: false, text: 'Horário de entrega?' },
        { checked: false, text: 'Qual o plano de manutenção?' },
        {
            checked: false,
            text: 'Condições consideradas para o check list dos equipamentos?'
        },
        { checked: false, text: 'Voltagem dos equipamentos?' },
        { checked: false, text: 'Ano de fabricação mínimo?' },
        { checked: false, text: 'Veículo com km livre?' },
        { checked: false, text: 'Operador do equipamento incluído?' },
        { checked: false, text: 'Prazo de renovação do contrato de locação?' },
        {
            checked: false,
            text: 'Possui Certidão Negativa de Débito de tributos federais?'
        },
        { checked: false, text: 'Possui Certidão Negativa de Débito de ICMS?' }
    ];
};

export const getProductQuestions = () => {
    return [
        { checked: false, text: 'Frete incluído?' },
        { checked: false, text: 'Ensaios necessários contemplados? Quais?' },
        { checked: false, text: 'Horário de entrega?' },
        { checked: false, text: 'Certificados necessários?' },
        { checked: false, text: 'Prazo de Entrega?' },
        { checked: false, text: 'Material já está disponível para estoque?' },
        {
            checked: false,
            text: 'Possui Certidão Negativa de Débito de tributos federais?'
        },
        { checked: false, text: 'Possui Certidão Negativa de Débito de ICMS?' }
    ];
};

export const getUpdatePasswordComponent = () => {
    return (
        '<div>' +
        '<form id="change-password-form" novalidate>' +
        '<div class="row">' +
        '<div class="col xl12 l12 m12 s12">' +
        '<div class="input-field">' +
        '<input id="current-password" type="password" name="current-password" v-model.trim="form.currentPassword" :class="{\'error\': $v.form.currentPassword.$error}" ref="currentPassword">' +
        '<label for="current-password">Senha atual</label>' +
        '<div class="error" v-show="$v.form.currentPassword.$dirty && !$v.form.currentPassword.required">Esse campo é obrigatório.</div>' +
        '</div>' +
        '<div class="input-field">' +
        '<input id="new-password" type="password" name="new-password" v-model.trim="form.newPassword" :class="{\'error\': $v.form.newPassword.$error}" ref="newPassword">' +
        '<label for="new-password">Nova senha</label>' +
        '<div class="error" v-show="$v.form.newPassword.$dirty && !$v.form.newPassword.required">Esse campo é obrigatório.</div>' +
        '</div>' +
        '<div class="input-field">' +
        '<input id="new-password-confirmation" type="password" name="new-password-confirmation" v-model.trim="form.newPasswordConfirmation" :class="{\'error\': $v.form.newPasswordConfirmation.$error}" ref="newPasswordConfirmation">' +
        '<label for="new-password-confirmation">Confirmação de senha</label>' +
        '<div class="error" v-show="$v.form.newPasswordConfirmation.$dirty && !$v.form.newPasswordConfirmation.required">Esse campo é obrigatório.</div>' +
        '<div class="error" v-show="$v.form.newPasswordConfirmation.$dirty && !$v.form.newPasswordConfirmation.sameAsPassword">As senhas não são iguais.</div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</form>' +
        '<div class="modal-footer">' +
        '<a class="modal-action modal-close btn-flat">Fechar</a>' +
        '<button class="modal-action btn blue darken-4" @click="validateUpdatePasswordForm">Atualizar senha</button>' +
        '</div>' +
        '</div>'
    );
};

export const getFreePlanInfo = () => {
    return {
        name: 'Gratuito',
        quotations: 'Participação limitada a 1 cotação por quinzena',
        sort: 'free'
    };
};

export const getPremiumPlusPlanInfo = () => {
    return {
        name: 'Premium Plus',
        sort: 'premium_plus'
    };
};

export const getEngelinkProPlanInfo = () => {
    return {
        name: 'Engelink Pro',
        sort: 'pro'
    };
};

export const getEnterprisePlanInfo = () => {
    return {
        name: 'Enterprise',
        sort: 'enterprise'
    };
};

export const showAttachmentErrorModal = () => {
    $('#attachment-upload-error-modal').modal('open');
};

export const getContactNetworkQuestionProfiles = () => {
    return [
        { value: 'basic', name: 'Básico', checked: false },
        { value: 'condo', name: 'Condomínio', checked: false },
        { value: 'civil-construction', name: 'Construção civil', checked: false },
        { value: 'supplier', name: 'Fornecedor', checked: false },
        { value: 'private-person', name: 'Cliente Engelink', checked: false },
        { value: 'corporative', name: 'Pessoa jurídica', checked: false },
        {
            value: 'professional-building-manager',
            name: 'Síndico profissional',
            checked: false
        }
    ];
};

export const getContactNetworkContactsProfiles = () => {
    return [
        { value: 'basic', name: 'Básico' },
        { value: 'condo', name: 'Condomínio' },
        { value: 'civil-construction', name: 'Construção civil' },
        { value: 'supplier', name: 'Fornecedor' },
        { value: 'corporative', name: 'Pessoa jurídica' },
        { value: 'private-person', name: 'Cliente Engelink' },
        { value: 'professional-building-manager', name: 'Síndico profissional' }
    ];
};

export const removeNonNumericCharacters = value => {
    return value.replace(/[^0-9*]/gi, '');
};

export const removeNonAlphanumericCharacters = value => {
    return value.replace(/[^a-z0-9*]/gi, '');
};

export const getMeetingStatusText = status => {
    switch (status) {
    case MEETING_STATUS.CONFIRMED:
        return 'Confirmado';
    case MEETING_STATUS.PENDING:
        return 'Pendente';
    case MEETING_STATUS.REJECTED:
        return 'Rejeitado';
    default:
        return 'Desconhecido';
    }
};

export const formatDatetime = element => {
    const currentDate = new Date(element.text().trim());
    const formattedDate = moment(currentDate, 'YYYY-MM-DD').format('DD/MM/YYYY HH:mm');
    element.text(formattedDate);
};

export const formatMeetingCreatedAt = element => {
    const currentDate = new Date(element.text().trim());
    const formattedDate = moment(currentDate, 'YYYY-MM-DD').format('DD/MM/YYYY HH:mm');
    element.text(formattedDate);
};

export const formatMeetingExpiresAt = (element, expirationDelay) => {
    const currentDate = new Date(element.text().trim());
    const formattedDate = moment(currentDate, 'YYYY-MM-DD')
        .add(expirationDelay, 'minutes')
        .format('DD/MM/YYYY HH:mm');
    element.text(formattedDate);
};

export const getPriceMask = () => {
    return {
        decimal: ',',
        masked: false,
        precision: 2,
        prefix: 'R$ ',
        thousands: '.'
    };
};

export const openDownloadModal = () => {
    $('#download-warning-modal').modal('open');
};

export const closeDownloadModal = () => {
    $('#download-warning-modal').modal('close');
};

export const appendQueryString = (url, value) => {
    if (!value) {
        return url;
    } else if (url.indexOf('?') === -1) {
        return url + '?' + value;
    } else {
        return url + '&' + value;
    }
};

export const getQueryStringByName = (url, name) => {
    if (url === undefined || !url) return null;
    const urlTemp = new URL(url);
    return urlTemp.searchParams.get(name);
};

export const openModal = selector => {
    $(selector).modal('open');
};

export const closeModal = selector => {
    $(selector).modal('close');
};

export const getSupplierCategories = () => {
    return [
        'Antenas',
        'Ar Condicionado e aquecedores',
        'Bombas hidráulicas',
        'Coberturas e telhados',
        'Comunicação visual',
        'Controle de pragas (dedetização)',
        'Desentupidora',
        'Elevadores',
        'Energia Solar',
        'Estofador',
        'Forros, gessos e divisórias',
        'Gerenciamento de obras',
        'Impermeabilização',
        'Individualização de hidrômetros',
        'Instalações de gás',
        'Instalações elétricas',
        'Instalações hidráulicas',
        'Jardinagem e Paisagismo',
        'Jogos, Brinquedos e Playgrounds',
        'Juridico, Contabilidade e Finanças',
        'Laudos e vistorias',
        'Limpeza de caixa d\'água',
        'Manutenção de aparelhos de ginástica',
        'Manutenção de brinquedos',
        'Manutenção de equipamentos de saunas',
        'Marcenaria',
        'Marmoraria',
        'Materia de limpeza',
        'Material de construção',
        'Material de escritório',
        'Obras e Reformas',
        'Pinturas e restaurações',
        'Piscinas, saunas e SPA',
        'Pisos e pavimentos',
        'Portas, Portões e janelas',
        'Prevenção e combate à Incêndios',
        'Projetos',
        'Recuperação de fachada',
        'Segurança e medicina do trabalho',
        'Serralheria',
        'Serviços de Limpeza',
        'Sistema de Proteção Contra Descargas Atmosféricas‎ - SPDA / Para-raio',
        'Sistemas de segurança, CFTV e acesso',
        'Sustentabilidade',
        'Síndico Profissional',
        'Terceirização de Serviços',
        'Terceirização de vigilante armado',
        'Vidraçaria'
    ];
};
export const makeNotificationNewQuotationData = form => {
    return {
        origin: 'new-quotation',
        construction: form.construction,
        constructionAddress: form.constructionStreet,
        constructionCep: form.constructionCep,
        constructionCity: form.constructionCity,
        constructionComplement: form.constructionComplement,
        constructionDistrict: form.constructionDistrict,
        constructionResponsible: form.quotationResponsible, // required
        constructionState: form.constructionState,
        constructionUnit: form.constructionUnit,
        costCenter: form.costCenter,
        endingDate: form.competitionEndingDate
            ? moment.utc(form.competitionEndingDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
            : null,
        files: form.attachments,
        items: {
            items: form.items
        },
        links: {
            links: form.links
        },
        obs: form.observation,
        phone: form.phone, // required
        phoneVisible: form.phoneVisible,
        supplierMaximumAmount: 1,
        title: form.competitionTitle,
        meetingInfo: form.meetingInfo,
        technicalVisitResponsible: form.meetingResponsible,
        technicalVisitResponsiblePhone: form.meetingPhone,
        requesterEmail: form.requesterEmail
    };
};
export const makeNotificationBannerData = form => {
    return {
        authenticated: form.authenticated,
        email: form.email ? form.email : '',
        job: form.job ? form.job : '',
        name: form.name, // required
        origin: form.origin ? form.origin : '',
        phone: form.phone, // required
        tradingName: form.tradingName ? form.tradingName : '',
        website: form.website ? form.website : '',
        send: false
    };
};

export const makeNotificationRequestQuotationData = form => {
    return {
        origin: 'request-quotation',
        construction: form.tradingName ? form.tradingName : '',
        construction_address: form.street ? form.street : '',
        construction_cep: form.cep ? form.cep : '',
        construction_city: form.city ? form.city : '',
        construction_district: form.neighborhood,
        construction_responsible: form.name, // required
        construction_state: form.state,
        construction_unit: form.unit,
        ending_date: form.dateLimit ? moment.utc(form.dateLimit, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
        files: form.attachments,
        obs: form.observations,
        phone: form.phone, // required
        supplier_maximum_amount: 1,
        title: form.category,
        meeting_info: form.meetingInfo,
        technical_visit_responsible_phone: form.meetingPhone,
        requester_email: form.email
    };
};

export const truncateString = (str, num) => {
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + '...';
};

export const capitalizeText = str => {
    if (typeof str !== 'string') {
        return '';
    }
    return str.charAt(0).toUpperCase() + str.substr(1);
};
